import TyLabel from './TyLabel.vue'
export default TyLabel



// WEBPACK FOOTER //
// ./src/components/ty-label/index.js